import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row bg-gray-100 w-full h-screen overflow-auto" }
const _hoisted_2 = { class: "flex flex-none flex-col w-[15rem] bg-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-none items-center space-x-4 h-[57px] shadow-sm box-border p-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Панель управления")
], -1)
const _hoisted_4 = { class: "flex flex-auto flex-col" }
const _hoisted_5 = { class: "flex flex-auto flex-col p-5" }

import TopBar from "@/components/blocks/TopBar.vue";
import LeftSidebar from "@/components/blocks/LeftSidebar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(LeftSidebar)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TopBar),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})